<template>
	<div id="RadioSelectQuestion">
		<div
			class="content-container text-prompt-container d-flex flex-column align-items-center animate__animated animate__fadeIn">
			<h3 class="pb-5 brand-text align-self-center ">{{ question.text }}</h3>
			<p class="pb-5 text-center" v-if="question.subtitle || question.body" v-html="question.subtitle ? question.subtitle : question.body"></p>
			<div v-for="(o, i) in question.items" class="w-100" @click="selectOption(o)">
				<RadioSelectOption class="w-100" :option="o" :selected="o.text === selectedOption.text && o.target_id === selectedOption.target_id" />
			</div>
			<div class="py-3 px-4 error-container mb-4 text-left" v-if="showErrors">
				<i class="fa-solid fa-triangle-exclamation"></i> You must select an option
			</div>
		</div>
	</div>
</template>
<script>
import RadioSelectOption from "./RadioSelectOption.vue";

export default {
	components: {
		RadioSelectOption
	},
	name: "component",
	data() {
		return {
			selectedOption: { text: null },
		};
	},
	mounted() {
		if (this.loadedAnswer) {
				let self = this;
				this.selectedOption = { text: this.loadedAnswer[0].value, target_id: this.loadedAnswer[0].target_id };
				this.updateAnswer({ question_id: this.question.id, items: self.loadedAnswer });
				this.$forceUpdate();
		}
	},
	beforeDestroy() {

	},
	methods: {
		selectOption(option) {
			if(option.specialist){
				this.updateAnswer(
					{ question_id: this.question.id, items: [{ type: 'radio', value: option.text, target_id: option.target_id, specialist: option.specialist }] }
				);
			}else{
				this.updateAnswer(
					{ question_id: this.question.id, items: [{ type: 'radio', value: option.text, target_id: option.target_id }] }
				);
			}
			this.selectedOption = option;
		}
	},
	watch: {
		loadedAnswer() {
			if (this.loadedAnswer) {
				let self = this;
				this.selectedOption = { text: this.loadedAnswer[0].value, target_id: this.loadedAnswer[0].target_id };
				this.updateAnswer({ question_id: this.question.id, items: self.loadedAnswer });
				this.$forceUpdate();
			}
		},
	},
	props: ['question', 'updateAnswer', 'showErrors', 'loadedAnswer'],

};
</script>
<style lang="less">
#RadioSelectQuestion {
	.text-prompt-container {
		max-width: 700px;
		font-size: 1.6rem;

		h3 {
			padding-top: 0;
			margin-top: 0;
			letter-spacing: normal;
			font-size: 1.8rem;
			text-align: center;
		}

		.error-container {

			width: 100%;
			background-color: #fbeacf;
			border-radius: 6px;

			i {
				color: red;
			}
		}

		.warning-info-container {
			font-family: "Montserrat", serif;
			font-weight: 700;
			background-color: white;
			padding: 20px;
			border: 2px solid #D60023;
			border-radius: 16px;
			margin-bottom: 25px;

			i {
				color: #D60023;
			}
		}

		.btn {
			margin-top: 30px;
			margin-bottom: 100px;
		}
	}
}
</style>